import React from "react";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import OverviewSection from "./OverviewSection";

const Comment = ({ comment, handleComment, isDelivery }) => {
    return (
        <OverviewSection title={!isDelivery ? "overview.commentTitle" : null}>
            {isDelivery && (
                <p className="comment_text">
                    {"Sollen wir noch was beachten?"}
                </p>
            )}
            <textarea
                id="comment"
                name="comment"
                placeholder={
                    !isDelivery
                        ? i18n.t("overview.commentPickupPlaceholder")
                        : i18n.t("overview.commentPlaceholder")
                }
                onChange={(e) => handleComment(e.target.value)}
                value={comment}
            />
        </OverviewSection>
    );
};

Comment.propTypes = {
    comment: PropTypes.string,
    handleComment: PropTypes.func.isRequired,
    isDelivery: PropTypes.bool,
};

export default Comment;
